const BCPMission = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12ZM21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM17.1887 8.07623L15.0687 14.4362C14.9691 14.7348 14.7348 14.9691 14.4362 15.0687L8.07623 17.1887C7.29447 17.4493 6.55073 16.7055 6.81132 15.9238L8.93132 9.56377C9.03085 9.26517 9.26517 9.03085 9.56377 8.93132L15.9238 6.81132C16.7055 6.55073 17.4493 7.29447 17.1887 8.07623ZM9.34114 14.6589L10.6706 10.6706L14.6589 9.34114L13.3294 13.3294L9.34114 14.6589Z"
        fill="#437EF7"
      />
    </svg>
  );
};

export default BCPMission;
